import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    listtodo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/tasktodo`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data:resp } = await axios.get(`tasktodo/detail/?key=${encodeURIComponent(obj.key)}`);
                // if (resp.success){
                //     resp.reportUrl = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${obj.key}`;
                // }
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    doaction(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("tasktodo/doaction", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },      
    mypending(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {data} = await axios.get(`tasktodo/mypending${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    teampending(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const {data} = await axios.get(`tasktodo/teampending${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalhistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`tasktodo/history/${obj.key}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalprint(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/tasktodo/historyprint/${obj.key}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    viewBudgetDept(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['departkd', 'departemen', 'tahun', 'layout'];

                let str = '?';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/budgetdept/viewprint${str}`;
                const { data } = await axios.get(url);
                console.log('data : ', data);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    attachmentSave(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("tasktodo/attachment", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    attachmentDownload(obj) {
        return new Promise((resolve, reject) => {
            try {
                axios({
                    url: `/tasktodo/attachment/${obj.attachmentKey}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', obj.attchFileNm);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getAttachment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/tasktodo/attachmentlist/${obj.taskkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    delAttachment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`/tasktodo/attachment/${obj.attachmentKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    

    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/apreval/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'apreval_list.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
        
}    
};